<script setup lang="ts">
	const { type = 'default' } = defineProps<{
		type?: 'default'|'large'
	}>()

	const lastRun = ref({})
	const cachedData = useNuxtData('last-run')
	if (cachedData.data.value) {
		lastRun.value = cachedData.data.value
	}

	const profile = ref({})
	const cachedDataProfile = useNuxtData('profile')
	if (cachedDataProfile.data.value && cachedDataProfile.data.value.info.count === 1) {
		profile.value = cachedDataProfile.data.value.items[0]
	}
</script>

<template>
	<template v-if="lastRun?.results_link && profile">
		<LayoutBtnDavengoLarge v-if="type =='large'" :label="profile.result_btn_label ? profile.result_btn_label : 'Ergebnisse'" :link="lastRun.results_link"></LayoutBtnDavengoLarge>
		<LayoutBtnDavengo v-else :label="profile.result_btn_label ? profile.result_btn_label : 'Ergebnisse'" :link="lastRun.results_link"></LayoutBtnDavengo>
	</template>
</template>
